import { useNavigate } from 'react-router-dom';

import { useGeneralDataContext } from '../../contexts/useGeneralDataContext/useGeneralDataContext';

import routes from '../../config/constants/routes';

const useNavigationHandler = () => {
  const navigate = useNavigate();
  const { language } = useGeneralDataContext();

  const createNavigationHandler = (
    id: number,
    route: string,
    wildcard: string,
  ) => {
    navigate(
      routes[language as keyof typeof routes][
        route as keyof (typeof routes)[keyof typeof routes]
      ].replace(wildcard, String(id)),
    );
  };

  return {
    createNavigationHandler,
  };
};

export default useNavigationHandler;
